import { AuditedFinancial } from "./AuditedFinancial";
import { SupportingDocs } from "./SupportingDocs";
import { OthersComponent } from "./OthersComponent";
import "./tab3content.css";

export const Documents = () => {
  return (
    <>
      <AuditedFinancial />
      <SupportingDocs />
    </>
  );
};
